import React, { useCallback, useEffect, useState, useRef } from 'react';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { NotesIcon } from '../../../Icons';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useNotes } from '../NotesContext';

const useStyles = makeStyles(() => ({
  noFocus: {
    '&:focus': {
      outline: 'none'
    }
  }
}));

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 800,
    fontSize: theme.typography.pxToRem(16),
    border: '1px solid #dadde9'
  }
}))(Tooltip);

const ContentGuidelineTooltip = ({ newPostProps }) => {
  const { getNotesForClient } = useNotes();
  const classes = useStyles();
  const [contentGuideLine, setContentGuideLine] = useState('');
  const hasLoaded = useRef(false);

  const loadContentGuideline = useCallback(async () => {
    const { currentClientId } = newPostProps;

    if (!currentClientId || hasLoaded.current) return;

    hasLoaded.current = true;

    try {
      const { Content_Guidelines_Notes } = await getNotesForClient(
        currentClientId,
        true
      );
      setContentGuideLine(Content_Guidelines_Notes || '');
    } catch (error) {
      console.error('Error loading content guideline:', error);
      setContentGuideLine('');
    }
  }, [newPostProps, getNotesForClient]);

  useEffect(() => {
    loadContentGuideline();
  }, [loadContentGuideline]);

  return (
    <HtmlTooltip
      title={contentGuideLine || 'No content guideline available'}
      placement="right-start"
      arrow>
      <Button size="small" className={`mb-3 p-0 ${classes.noFocus}`}>
        <NotesIcon className="mr-1" width={'22'} height={'22'} />
        CONTENT GUIDELINE
      </Button>
    </HtmlTooltip>
  );
};

export default ContentGuidelineTooltip;
